(function () {
  var GIFT_VARIANT_ID = 59492000923993;
  var THRESHOLD = 5000; // 50,00 €
  var isUpdating = false;
  var debounceTimer = null;

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json'
      }
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart konnte nicht geladen werden');
      return res.json();
    });
  }

  function findGiftItem(cart) {
    if (!cart || !cart.items) return null;
    return cart.items.find(function (item) {
      return item.variant_id === GIFT_VARIANT_ID;
    }) || null;
  }

  function getCartTotalWithoutGift(cart) {
    var giftItem = findGiftItem(cart);
    var giftValue = giftItem ? giftItem.final_line_price : 0;
    return (cart.total_price || 0) - giftValue;
  }

  function addGift() {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: GIFT_VARIANT_ID,
        quantity: 1
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || JSON.stringify(data));
        }
        return data;
      });
    });
  }

  function removeGift(lineKey) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: 0
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || 'Gratisartikel konnte nicht entfernt werden');
        }
        return data;
      });
    });
  }

  function setGiftQuantity(lineKey, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity
      })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          throw new Error(data.description || data.message || 'Gratisartikel-Menge konnte nicht geändert werden');
        }
        return data;
      });
    });
  }

  function replaceInner(selector, doc) {
    var currentEl = document.querySelector(selector);
    var newEl = doc.querySelector(selector);

    if (currentEl && newEl) {
      currentEl.innerHTML = newEl.innerHTML;
      return true;
    }

    return false;
  }

  function replaceOuter(selector, doc) {
    var currentEl = document.querySelector(selector);
    var newEl = doc.querySelector(selector);

    if (currentEl && newEl) {
      currentEl.replaceWith(newEl.cloneNode(true));
      return true;
    }

    return false;
  }

  function rerenderCartUI() {
    return fetch(window.location.href, {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/html'
      }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Seite konnte nicht neu geladen werden');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        replaceOuter('cart-drawer-component', doc);
        replaceOuter('.cart-drawer', doc);

        replaceInner('.cart-drawer__dialog', doc);
        replaceInner('.cart-drawer__inner', doc);
        replaceInner('.cart-items-component', doc);
        replaceInner('.cart-drawer__content', doc);
        replaceInner('.cart-drawer__summary', doc);
        replaceInner('.cart-drawer__header', doc);

        replaceOuter('#cart-icon-bubble', doc);
        replaceOuter('.cart-bubble', doc);
        replaceOuter('.cart-count-bubble', doc);

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:update'));
        document.dispatchEvent(new CustomEvent('cart:change'));

        disableGiftQuantityControls();
      })
      .catch(function (error) {
        console.error('Cart rerender error:', error);
      });
  }

  function disableGiftQuantityControls() {
    var cartRows = document.querySelectorAll('[data-cart-item], .cart-item, .drawer__cart-item, .cart-drawer-item');

    cartRows.forEach(function (row) {
      var rowText = row.textContent || '';
      var hasGiftId =
        row.innerHTML.indexOf(String(GIFT_VARIANT_ID)) !== -1 ||
        rowText.indexOf('Gratis') !== -1 ||
        rowText.indexOf('kostenlos') !== -1;

      if (!hasGiftId) return;

      var plusButtons = row.querySelectorAll('.quantity__button[name="plus"], .quantity__button.plus, [data-quantity-plus]');
      plusButtons.forEach(function (btn) {
        btn.disabled = true;
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.4';
      });

      var inputs = row.querySelectorAll('.quantity__input, input[name="updates[]"], [name="quantity"]');
      inputs.forEach(function (input) {
        input.setAttribute('max', '1');
        if (parseInt(input.value, 10) > 1) {
          input.value = 1;
        }
      });
    });
  }

  function syncFreeGift() {
    if (isUpdating) return Promise.resolve();
    isUpdating = true;

    return getCart()
      .then(function (cart) {
        var giftItem = findGiftItem(cart);
        var totalWithoutGift = getCartTotalWithoutGift(cart);
        var qualifies = totalWithoutGift >= THRESHOLD;

        if (qualifies && !giftItem) {
          return addGift().then(function () {
            return rerenderCartUI();
          });
        }

        if (!qualifies && giftItem) {
          return removeGift(giftItem.key).then(function () {
            return rerenderCartUI();
          });
        }

        if (qualifies && giftItem && giftItem.quantity > 1) {
          return setGiftQuantity(giftItem.key, 1).then(function () {
            return rerenderCartUI();
          });
        }

        disableGiftQuantityControls();
        return Promise.resolve();
      })
      .catch(function (error) {
        console.error('Free gift error:', error);
      })
      .finally(function () {
        isUpdating = false;
      });
  }

  function scheduleUpdate(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      syncFreeGift();
    }, delay || 500);
  }

  function handleCheckoutClick(event) {
    var checkoutTrigger = event.target.closest(
      'button[name="checkout"], a[href="/checkout"], a[href*="/checkout"], button[data-checkout], input[name="checkout"]'
    );

    if (!checkoutTrigger) return;

    event.preventDefault();

    syncFreeGift()
      .then(function () {
        return getCart();
      })
      .then(function (cart) {
        var giftItem = findGiftItem(cart);
        var totalWithoutGift = getCartTotalWithoutGift(cart);
        var qualifies = totalWithoutGift >= THRESHOLD;

        if (!qualifies && giftItem) {
          return removeGift(giftItem.key).then(function () {
            window.location.href = '/checkout';
          });
        }

        if (qualifies && giftItem && giftItem.quantity > 1) {
          return setGiftQuantity(giftItem.key, 1).then(function () {
            window.location.href = '/checkout';
          });
        }

        window.location.href = '/checkout';
      })
      .catch(function () {
        window.location.href = '/checkout';
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleUpdate(250);
    disableGiftQuantityControls();
  });

  document.addEventListener('click', function (event) {
    handleCheckoutClick(event);

    var trigger = event.target.closest(
      'button[name="add"], .product-form__submit, [data-add-to-cart], .ajax-cart__qty-adjust, .quantity__button, .cart-remove, [href*="/cart/change"]'
    );

    if (trigger) {
      scheduleUpdate(500);
    }
  });

  document.addEventListener('change', function (event) {
    if (
      event.target.matches('input[name="updates[]"]') ||
      event.target.matches('[name="quantity"]') ||
      event.target.matches('.quantity__input')
    ) {
      scheduleUpdate(550);
    }
  });
})();